// Vite: public folder is served at base URL. Put images in public/images/
const base =
  typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env.BASE_URL : '/cashloan/'

const IMAGE_PATHS = {
  error: 'images/error.png',
  logoPayuFinanceWhite: 'images/logos/logo-white-payu-finance.png',
  warningInfo: 'images/warning_info.png',
  warningSign: 'images/warning_sign.png',
  letter: 'images/letter.png',
  agreement: 'images/agreement.png',
  signOut: 'images/sign_out.png',
  bgIcon: 'images/bg-icon.png',
  splitLayoutBg: 'images/bg.png',
  home: 'images/home.svg',
  profile: 'images/profile.svg',
  history: 'images/history.png',
  paymentFailedIcon: 'images/payment_failed_icon.png',
  greenTick: 'images/green_tick.png'
}

const IMAGE_MAPPING = {
  error: base + IMAGE_PATHS.error,
  payufin_logo:
    'https://prod-assets-payufin.s3.ap-south-1.amazonaws.com/images/payu-finance-new-logo.png',
  logoPayuFinanceWhite: base + IMAGE_PATHS.logoPayuFinanceWhite,
  warningInfo: base + IMAGE_PATHS.warningInfo,
  warningSign: base + IMAGE_PATHS.warningSign,
  letter: base + IMAGE_PATHS.letter,
  agreement: base + IMAGE_PATHS.agreement,
  signOut: base + IMAGE_PATHS.signOut,
  bgIcon: base + IMAGE_PATHS.bgIcon,
  splitLayoutBg: base + IMAGE_PATHS.splitLayoutBg,
  home: base + IMAGE_PATHS.home,
  profile: base + IMAGE_PATHS.profile,
  history: base + IMAGE_PATHS.history,
  paymentFailedIcon: base + IMAGE_PATHS.paymentFailedIcon,
  greenTick: base + IMAGE_PATHS.greenTick
}

export const getImageUrl = icon => IMAGE_MAPPING[icon] ?? IMAGE_MAPPING.error
